import { useState } from "react";
import { OpportunityCardDetails } from "../../shared/OpportunityCard";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function OpportunityPickerItem({
    opportunity,
    isSelected = false,
    selectDisabled = false,
    onToggleSelect,
}) {
    const [expanded, setExpanded] = useState(false);
    const { title, opportunity: opportunityText } = opportunity ?? {};

    return (
        <article className="rounded-xl border border-slate-200 bg-white p-4 transition hover:border-slate-300">
            {title ? (
                <h3 className="mb-1 text-base font-semibold leading-snug text-slate-900">
                    {title}
                </h3>
            ) : null}
            {opportunityText ? (
                <p
                    className={`mb-0 text-sm leading-relaxed text-slate-600 ${
                        expanded ? "" : "line-clamp-2"
                    }`}
                >
                    {opportunityText}
                </p>
            ) : null}

            <div className="mt-3 flex flex-wrap items-center gap-2">
                <button
                    type="button"
                    onClick={() => setExpanded((prev) => !prev)}
                    className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
                >
                    <i
                        className={`bi ${expanded ? "bi-chevron-up" : "bi-chevron-down"}`}
                        aria-hidden
                    />
                    {expanded ? "Hide details" : "View details"}
                </button>
                <button
                    type="button"
                    onClick={() => onToggleSelect(opportunity)}
                    disabled={selectDisabled && !isSelected}
                    className={`inline-flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-semibold transition ${
                        isSelected
                            ? "bg-emerald-600 text-white hover:bg-emerald-700"
                            : "bg-orange-700 text-white hover:bg-orange-800 disabled:cursor-not-allowed disabled:opacity-40"
                    }`}
                >
                    <i className={`bi ${isSelected ? "bi-check2" : "bi-arrow-right"}`} aria-hidden />
                    {isSelected ? "Using This Trend" : "Use This Trend"}
                </button>
            </div>

            {expanded ? (
                <div className="mt-4 border-t border-slate-100 pt-4">
                    <OpportunityCardDetails opportunity={opportunity} />
                </div>
            ) : null}
        </article>
    );
}
